export default "__VITE_ASSET__TSFEUpic__"